import { Box, Link, Text } from '@chakra-ui/react';
import PropTypes from 'prop-types';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';

const markdownComponents = {
  p: ({ children }) => <Text as="p">{children}</Text>,
  ul: ({ children }) => <Box as="ul">{children}</Box>,
  ol: ({ children }) => <Box as="ol">{children}</Box>,
  li: ({ children }) => <Box as="li">{children}</Box>,
  strong: ({ children }) => (
    <Text as="strong" fontWeight={600}>
      {children}
    </Text>
  ),
  em: ({ children }) => <Text as="em">{children}</Text>,
  a: ({ href, children }) => {
    const safeHref =
      href && /^(https?:|mailto:|#)/i.test(href) ? href : undefined;
    return (
      <Link href={safeHref} isExternal={Boolean(safeHref)} color="purple.600">
        {children}
      </Link>
    );
  },
  h1: ({ children }) => <Text as="h1">{children}</Text>,
  h2: ({ children }) => <Text as="h2">{children}</Text>,
  h3: ({ children }) => <Text as="h3">{children}</Text>,
  h4: ({ children }) => <Text as="h4">{children}</Text>,
  code: ({ children }) => <Text as="code">{children}</Text>,
  pre: ({ children }) => <Box as="pre">{children}</Box>,
};

function AssistChatMarkdown({ text }) {
  if (!text) {
    return null;
  }
  return (
    <ReactMarkdown remarkPlugins={[remarkGfm]} components={markdownComponents}>
      {text}
    </ReactMarkdown>
  );
}

AssistChatMarkdown.propTypes = {
  text: PropTypes.string,
};

export default AssistChatMarkdown;
